const Noop = props => <div {...props} />;

export {Noop};
